// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1E1J-","selects":"Documents_selects__2auEM"};